export default __webpack_public_path__ + "static/media/headerc.09c997b9.jpg";